// extracted by mini-css-extract-plugin
module.exports = {"root":"GrayInfoBox_root__HjQmU","label":"GrayInfoBox_label__2g-DU","textContainer":"GrayInfoBox_textContainer__3_Usp"};